const api = 'https://tools-eject.chargespot.jp/sw.php?'

const postReqest = async (formData, endpoint) => {
  const result = await fetch(`${api}m=${endpoint}&v=2`, {
    method: 'POST',
    mode: 'cors',
    body: formData
  })
    .then((res) => res.json())
    .catch((reason) => {
      console.log('error msg:', reason)
    })
  return result
}

const getCabinetStatus = async (user, id) => {
  const formData = new FormData()
  formData.append('user', user)
  formData.append('cabinetId', id)
  const result = await postReqest(formData, 'cabinet')
  return result.result
}

const getCabinetStatusByUUID = async (user, uuid) => {
  const formData = new FormData()
  formData.append('user', user)
  formData.append('uuid', uuid)
  const result = await postReqest(formData, 'cabinet')
  return result.result
}

const startWork = async (user, cabinetId) => {
  const formData = new FormData()
  formData.append('user', user)
  formData.append('cabinetId', cabinetId)
  const result = await postReqest(formData, 'start')
  return result.result
}

const endWork = async (user, cabinetId, startPb) => {
  const formData = new FormData()
  formData.append('user', user)
  formData.append('cabinetId', cabinetId)
  formData.append('startPb', startPb)
  const result = await postReqest(formData, 'done')
  return result.result
}

const exportButtery = async (user, id, quantity) => {
  const formData = new FormData()
  formData.append('user', user)
  formData.append('id', String(id))
  formData.append('quantity', String(quantity))
  const result = await postReqest(formData, 'releaseNum')
  return result.result
}

const exportButteryByIndex = async (user, id, index) => {
  const formData = new FormData()
  formData.append('user', user)
  formData.append('id', String(id))
  formData.append('index', String(index))
  const result = await postReqest(formData, 'releaseSlot')
  return result.result
}

module.exports = {
  getCabinetStatus,
  getCabinetStatusByUUID,
  startWork,
  endWork,
  exportButtery,
  exportButteryByIndex
}
